import { render, staticRenderFns } from "./SummaryBrandCategory.vue?vue&type=template&id=a2d9aa0e"
import script from "./SummaryBrandCategory.vue?vue&type=script&lang=js"
export * from "./SummaryBrandCategory.vue?vue&type=script&lang=js"
import style0 from "./SummaryBrandCategory.vue?vue&type=style&index=0&id=a2d9aa0e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports